import '@/styles/index.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'

const app = createApp(App)

app.use(createPinia())
app.use(router)

Sentry.init({
  app,
  dsn: 'https://d3894bb2b46ce408234e135e0f7d244a@o62542.ingest.us.sentry.io/4507707945451520',
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

router.isReady().then(() => app.mount('#app'))
